import { useQuery } from '@tanstack/react-query'
import instance from '../api'
import { useAuthContext } from '../../context/auth/auth'
import { OrganizationTypes } from '../../interfaces/organization'

const getOrganizations = async (
  token: string,
): Promise<OrganizationTypes[]> => {
  const response = await instance.get('/organizations/organization/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data.data
}

const useOrganizations = () => {
  const { token } = useAuthContext()
  return useQuery({
    queryKey: ['organizations'],
    queryFn: () => getOrganizations(token!),
  })
}

export default useOrganizations
